import { createContext } from 'react';
const FormsContext = /*#__PURE__*/createContext({});
export default FormsContext;